/* eslint-disable react-hooks/exhaustive-deps */
/** @jsxImportSource @emotion/react */
import 'twin.macro';

import { ChunkedEditorShell } from 'components/VideoPlayer/Transcription/MediaPlayer/Transcript/ChunkedEditorShell';
import { useState } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { RootState } from 'reducers';

type Props = {
  /** Binds chunk store to media + transcript revision (latest or history version). */
  documentKey?: string | null;
};

export const ParagraphEditor = ({ documentKey }: Props) => {
  const paragraph = useSelector((state: RootState) => state.player.paragraph);
  const { id: mediaid } = useParams<{ id: string }>();
  const boundDocumentKey = documentKey
    ? `${documentKey}:paragraph`
    : `${mediaid ?? 'media'}:paragraph`;

  // Playback highlight is DOM/rAF — do not push timeupdate into React state.
  const [currentTime] = useState(0);

  return (
    <div>
      <ErrorBoundary
        fallback={
          <div tw="font-medium text-sonnant-grey-6 text-16 mt-5">
            Cannot load content item's transcripts
          </div>
        }
        onError={(e) => console.log('Paragraph Error:', e)}
      >
        <ChunkedEditorShell
          fullDocument={paragraph ?? []}
          videoTimePosition={currentTime}
          documentKey={boundDocumentKey}
        />
      </ErrorBoundary>
    </div>
  );
};
